import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: "Comment est calculée l'estimation de mon bien ?",
    answer: "Notre estimation s'appuie sur une analyse approfondie de plusieurs facteurs clés : les données du marché immobilier local, l'historique des transactions récentes dans votre quartier, les caractéristiques spécifiques de votre bien (surface, nombre de pièces, étage, etc.), et les tendances actuelles du marché. Nous utilisons un algorithme sophistiqué qui prend en compte plus de 100 critères pour vous fournir l'estimation la plus précise possible."
  },
  {
    question: "Quelle est la fiabilité des estimations ?",
    answer: "Nos estimations sont fiables à 95% avec une marge d'erreur moyenne de 5%. Cette précision est obtenue grâce à notre base de données constamment mise à jour et notre connaissance approfondie du marché immobilier local. Nous analysons des milliers de transactions récentes pour affiner nos estimations et les adapter aux spécificités de chaque quartier."
  },
  {
    question: "Combien de temps prend l'estimation en ligne ?",
    answer: "L'estimation en ligne ne prend que 2 minutes. Il vous suffit de remplir un formulaire simple avec les informations essentielles de votre bien. Pour une estimation plus détaillée, nous pouvons organiser une visite sur place avec l'un de nos experts immobiliers locaux."
  },
  {
    question: "Les estimations sont-elles vraiment gratuites ?",
    answer: "Oui, nos estimations en ligne sont totalement gratuites et sans engagement. Nous croyons en la transparence et souhaitons vous permettre d'avoir une première idée de la valeur de votre bien sans aucun frais. Si vous souhaitez par la suite une estimation plus approfondie avec visite sur place, nous vous proposerons ce service complémentaire."
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleQuestion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" aria-label="Questions fréquentes" className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Questions fréquentes
        </h2>

        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-white/80 backdrop-blur-xl shadow-[0_8px_32px_rgba(42,67,101,0.15)]
                transform hover:scale-[1.01] transition-all duration-300
                relative overflow-hidden rounded-xl"
            >
              <button
                onClick={() => toggleQuestion(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none relative z-10"
              >
                <span className="text-lg font-medium text-gray-900">
                  {item.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-[#2A4365] transition-transform duration-200 ${
                    openIndex === index ? 'transform rotate-180' : ''
                  }`}
                  strokeWidth={2.5}
                />
              </button>

              <div
                className={`px-6 overflow-hidden transition-all duration-200 relative z-10 ${
                  openIndex === index ? 'py-4' : 'max-h-0'
                }`}
              >
                <p className="text-gray-700 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}